(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\b(?:aop|aoc|igp|docg?|appellation d origine protegee)\b/g, ' ').replace(/\bst[ .-]/g, 'saint ').replace(/[^a-z0-9]+/g, ' ').replace(/\bcotes?\b/g, 'cote').replace(/\bcatalanes?\b/g, 'catalane').replace(/\s+/g, ' ').trim();
  const clean = value => String(value || '').replace(/\b(?:AOP|AOC|IGP|DOCG?)\b/gi, '').replace(/\s+/g, ' ').trim();
  const appellations = 'Côtes du Rhône Villages Vaison-la-Romaine|Côtes du Rhône Villages Plan de Dieu|Côtes du Rhône Villages Visan|Côtes du Rhône Villages Laudun|Côtes du Rhône Villages|Côtes du Rhône|Côtes du Roussillon Villages Tautavel|Côtes du Roussillon Villages|Côtes du Roussillon|Côtes de Provence Cru Sainte-Victoire|Côtes de Provence|Côte de Brouilly|Côte de Nuits-Villages|Côte-de-Beaune-Villages|Côte-Rôtie|Côtes Catalanes|Côte Vermeille|Bourgogne Hautes-Côtes de Nuits|Bourgogne Hautes-Côtes de Beaune|Hautes-Côtes de Nuits|Hautes-Côtes de Beaune|Bourgogne Aligoté|Bourgogne Passetoutgrain|Bourgogne|Chablis Grand Cru|Chablis Premier Cru|Petit Chablis|Chablis|Aloxe-Corton|Alsace Grand Cru Pfingstberg|Alsace|Bandol|Beaune|Bordeaux Supérieur|Bordeaux|Bourgueil|Brouilly|Bâtard-Montrachet|Cairanne|Cassis|Chambolle-Musigny|Charmes-Chambertin|Chassagne-Montrachet|Chinon|Chorey-lès-Beaune|Châteauneuf-du-Pape|Clairette de Bellegarde|Clos de Vougeot|Collioure|Condrieu|Cornas|Corse-Calvi|Corton-Charlemagne|Costières de Nîmes|Crozes-Hermitage|Crémant de Bourgogne|Crémant de Loire|Fitou|Fixin|Gigondas|Givry|Graves|Pic Saint-Loup|La Clape|Lalande-de-Pomerol|Clairette du Languedoc|Languedoc|Limoux|Lirac|Maranges|Margaux|Mercurey|Meursault|Monbazillac|Montagny|Monthélie|Mâcon-Villages|Mâcon|Médoc|Nuits-Saint-Georges|Pauillac|Pernand-Vergelesses|Pessac-Léognan|Pommard|Pouilly-Fuissé|Pouilly-Fumé|Blanc Fumé de Pouilly|Puisseguin-Saint-Émilion|Puligny-Montrachet|Saint-Estèphe|Saint-Joseph|Saint-Julien|Saint-Péray|Saint-Romain|Saint-Véran|Saint-Émilion Grand Cru|Saint-Émilion|Saint-Nicolas-de-Bourgueil|Santenay|Savigny-lès-Beaune|Saumur Champigny|Saumur|Sancerre|Menetou-Salon|Touraine|Vacqueyras|Ventoux|Viré-Clessé|Volnay|Vosne-Romanée|Pomerol|Beaumes-de-Venise|Pays d’Oc|Île-de-Beauté|Méditerranée|Périgord|Vaucluse Principauté d’Orange|Vaucluse|Val de Loire|Champagne|Prosecco|Hermitage|Vin de France'.split('|').map(label => ({ label, normalized: normalize(label) })).sort((a, b) => b.normalized.length - a.normalized.length);
  function appellation(value) {
    const tail = String(value).split(/\b(?:AOP|AOC|IGP|DOCG?)\b/i).pop();
    const n = ` ${normalize(tail)} `;
    const match = appellations.find(a => n.includes(` ${a.normalized} `));
    return match ? (match.label === 'Blanc Fumé de Pouilly' ? 'Pouilly-Fumé' : match.label) : clean(value);
  }
  function near(a, b) {
    if (a.length < 4 || Math.abs(a.length - b.length) > 1) return false;
    let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
    for (let i = 1; i <= a.length; i++) {
      const next = [i];
      for (let j = 1; j <= b.length; j++) next[j] = Math.min(next[j - 1] + 1, prev[j] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = next;
    }
    return prev[b.length] <= 1;
  }
  function score(query, value) {
    const q = normalize(query), v = normalize(value);
    if (!q) return -1;
    if (q === v) return 0;
    if (v.startsWith(q) || v.split(' ').some(w => w.startsWith(q))) return 1;
    if (q.length >= 5 && v.split(' ').some(w => near(q, w.slice(0, q.length)))) return 2;
    const qt = q.split(' '), vt = v.split(' ');
    if (qt.every(t => vt.some(w => w.startsWith(t)))) return 2;
    if (qt.every(t => vt.some(w => w.startsWith(t) || near(t, w)))) return 3;
    return -1;
  }
  const priceValue = value => Number(String(value || '').replace(/[^0-9,.-]/g, '').replace(',', '.')) || 0;
  const key = 'pm-wine-search-v5-prix-publics-20261018';
  const storage = {
    get() { try { return JSON.parse(sessionStorage.getItem(key)) || {}; } catch { return {}; } },
    set(value) { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} }
  };
  function element(tag, className, text) {
    const e = document.createElement(tag);
    if (className) e.className = className;
    if (text !== undefined) e.textContent = text;
    return e;
  }
  const icon = '<svg aria-hidden="true" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/></svg>';
  let cleanup = () => {};
  function init() {
    cleanup();
    const config = document.getElementById('pm-wine-search-config');
    if (!config) return;
    const abort = new AbortController(), signal = abort.signal;
    const on = (target, event, callback) => target.addEventListener(event, callback, { signal });
    const root = document.getElementById('pm-new-parcours');
    const texts = JSON.parse(config.querySelector('[data-pm-search-texts]').textContent);
    const t = (name, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replace(`{${k}}`, v), texts[name] || name);
    const cached = storage.get();
    const cacheValid = cached.designMode === config.dataset.designMode && Date.now() - (cached.updated || 0) < 4 * 60 * 60 * 1000;
    let entries = [], selected = cacheValid ? cached.selected : null;
    const cards = new Map(), widgets = [];
    if (root) {
      const seen = new Set();
      root.querySelectorAll('.pm-e240[data-pm-selection]').forEach(panel => {
        panel.querySelectorAll('.pm-gb-card').forEach(card => {
          const title = card.querySelector('.pm-rhone-card-title'), link = card.querySelector('a[href]');
          if (!title || !link) return;
          const spans = title.children;
          const url = new URL(link.href, location.origin);
          const productId = card.dataset.pmProductId || card.dataset.pmDraftProduct || '';
          const id = `${panel.id}:${productId || url.pathname}`;
          if (seen.has(id)) return;
          seen.add(id);
          const e = {
            id, productId, panel: panel.id.replace('pm-vue-', ''), selection: panel.dataset.pmSelection,
            region: ({gb:'Languedoc',bodin:'Cassis',culombu:'Corse',bordeaux240:'Bordeaux',bourgogne240:'Bourgogne',catalanes240:'Côtes Catalanes',italie240:'Italie',provence240:'Provence Méditerranée',rhone240:'Vallée du Rhône',alsace18:'Alsace',bandol18:'Bandol',bordeaux18:'Bordeaux',bourgogne18:'Bourgogne',champagne18:'Champagne',loire18:'Vallée de la Loire',rhone18:'Vallée du Rhône',bourgogne24:'Bourgogne',loire24:'Vallée de la Loire',rhone24:'Vallée du Rhône'})[panel.id.replace('pm-vue-', '')] || panel.dataset.pmRegion, domain: spans[0]?.textContent.trim() || '',
            wine: (spans[1]?.textContent || '').replace(/\s+/g, ' ').trim(), appellation: appellation(spans[1]?.textContent || ''),
            detail: [spans[2]?.textContent.trim(), spans[3]?.textContent.trim()].filter(Boolean).join(' · '),
            price: card.querySelector('.pm-rhone-card-price strong')?.textContent.trim() || '',
            comparePrice: card.querySelector('.pm-rhone-card-price s')?.textContent.trim() || '',
            pack: card.querySelector('.pm-rhone-pack')?.textContent.trim() || '',
            href: url.pathname, draft: !!card.dataset.pmDraftProduct
          };
          if (!e.wine) return;
          entries.push(e); cards.set(id, card);
          on(link, 'click', () => remember(e));
        });
      });
      if (selected) selected = entries.find(e => e.id === selected.id) || null;
    } else if (cacheValid && Array.isArray(cached.entries)) {
      entries = cached.entries;
      const currentId = config.dataset.productId;
      if (currentId) selected = entries.find(e => e.productId === currentId && (!selected || e.selection === selected.selection)) || entries.find(e => e.productId === currentId) || null;
    }
    const persist = () => storage.set({ entries, selected, updated: Date.now(), designMode: config.dataset.designMode });
    persist();
    function remember(e) { selected = e; persist(); }
    function choose(e) {
      remember(e);
      widgets.forEach(w => w.close());
      if (!root) return;
      const panel = root.querySelector(`#pm-vue-${e.panel}`), card = cards.get(e.id);
      const filter = panel?.querySelector('.pm-rhone-domain-filter');
      if (filter) { filter.value = ''; filter.dispatchEvent(new Event('change')); }
      root.querySelectorAll('.pm-search-selected').forEach(c => c.classList.remove('pm-search-selected'));
      card?.classList.add('pm-search-selected');
      location.hash = `pm-selection-${e.panel}`;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const target = card;
        target?.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        if (card) { card.tabIndex = -1; card.focus({ preventScroll: true }); }
      }));
    }
    function addSearch(host, scope, suffix, after) {
      if (!host || host.querySelector(':scope > .pm-wine-search')) return;
      const box = element('div', 'pm-wine-search');
      const label = element('label', '', t('home_hint').replace(/\.$/, '')); label.htmlFor = `pm-search-${suffix}`;
      const controls = element('div', 'pm-search-control');
      const magnifier = element('span', 'pm-search-icon'); magnifier.innerHTML = icon;
      const input = element('input'); input.type = 'search'; input.id = label.htmlFor; input.placeholder = t('placeholder'); input.autocomplete = 'off'; input.spellcheck = false;
      input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-expanded', 'false');
      const clear = element('button', 'pm-search-clear', '×'); clear.type = 'button'; clear.setAttribute('aria-label', t('clear')); clear.hidden = true;
      const popup = element('div', 'pm-search-popup'); popup.id = `pm-search-results-${suffix}`; popup.hidden = true;
      const list = element('div', 'pm-search-options'); list.id = `${popup.id}-list`; list.setAttribute('role', 'listbox'); list.setAttribute('aria-label', t('suggestions'));
      input.setAttribute('aria-controls', list.id);
      const status = element('span', 'pm-search-sr'); status.setAttribute('role', 'status');
      controls.append(magnifier, input, clear); box.append(label, controls); box.append(popup, status); const offerNotice = suffix === 'home' ? host.querySelector('.pm-offers-discovery') : null; if (offerNotice) offerNotice.before(box); else if (after) after.after(box); else host.append(box);
      let active = -1, options = [], limit = 24;
      const pool = () => entries;
      function close() { popup.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
      function optionMobile(e) {
        const o = element('div', 'pm-search-option pm-search-option-mobile');
        o.setAttribute('role', 'option');
        o.id = `${list.id}-${options.length}`;
        o.setAttribute('aria-selected', 'false');
        const rawWine = String(e.wine || '').replace(/\s+/g, ' ').trim();
        // Respecter le nom exact de la carte region : ne pas reconstituer l'appellation.
        // Une cuvee entre guillemets est simplement presentee sur sa propre ligne.
        const quoted = rawWine.match(/^(.+?)\s*([«\"][\s\S]*?[»\"])(.*)$/);
        const heading = element('div', 'pm-result-title');
        heading.append(element('strong', 'pm-result-appellation', quoted ? quoted[1].trim() : rawWine));
        if (quoted) {
          const cuvee = (quoted[2] + quoted[3]).trim();
          heading.append(element('strong', 'pm-result-cuvee', cuvee));
        }
        const domain = String(e.domain || '').replace(/[«»\"]/g, '').trim();
        if (domain) heading.append(element('span', 'pm-result-domain', domain));
        heading.append(element('span', 'pm-result-separator'));

        const detail = String(e.detail || '').replace(/\s+/g, ' ').trim();
        const parts = detail.split(/\s*[·•]\s*/).filter(Boolean);
        const formatIndex = parts.findIndex(v => /\b\d+(?:[,.]\d+)?\s*cl\b/i.test(v));
        const format = formatIndex >= 0 ? parts.splice(formatIndex, 1)[0].trim() : '';
        let metaText = parts.join(' · ').replace(/^\s*[–—-]\s*/, '').trim();
        const fullMeta = [metaText, format].filter(Boolean).join(' · ');
        // Determiner la couleur a partir de la ligne couleur/millesime, pas de la cuvee.
        const color = /\bros[eé]\b/i.test(metaText) ? 'rose' : /\borange\b/i.test(metaText) ? 'orange' : /\brouge\b/i.test(metaText) ? 'red' : /\bblanc\b/i.test(metaText) ? 'white' : 'unknown';
        const champagne = /champagne/i.test([e.appellation, e.wine, e.region].join(' '));
        const tone = color === 'rose' ? '#e998a6' : color === 'orange' ? '#e9a13a' : color === 'red' ? '#92263f' : '#e7c65f';
        const meta = element('div', 'pm-result-meta');
        const glass = element('span', 'pm-wine-glass');
        glass.setAttribute('aria-hidden', 'true');
        const ns = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(ns,'svg');
        svg.setAttribute('viewBox', '0 0 28 32');
        svg.setAttribute('width', '21'); svg.setAttribute('height', '24');
        svg.setAttribute('fill', 'none'); svg.setAttribute('aria-hidden','true');
        const addPath = (d, fill, stroke, width) => {
          const p = document.createElementNS(ns,'path'); p.setAttribute('d',d);
          if (fill) p.setAttribute('fill',fill);
          if (stroke) {p.setAttribute('stroke',stroke);p.setAttribute('stroke-width',width||'1.3');p.setAttribute('stroke-linecap','round');p.setAttribute('stroke-linejoin','round');}
          svg.append(p);
        };
        if (champagne) {
          // Flute a champagne, avec vin jaune pale ou rose selon la couleur de la fiche.
          addPath('M8 3 H20 L18.3 16 Q17.7 21 14 21 Q10.3 21 9.7 16 Z','rgba(255,255,255,.76)','#87223c','1.2');
          addPath('M9.7 9 H18.3 L17.6 15.6 Q17.3 19.3 14 19.3 Q10.7 19.3 10.4 15.6 Z',tone);
          addPath('M14 21 V28 M9 29 H19',null,'#87223c','1.5');
          [ [12,11,1.1],[15.4,13.2,.8],[13.8,16,.7] ].forEach(([x,y,r])=>{const c=document.createElementNS(ns,'circle');c.setAttribute('cx',x);c.setAttribute('cy',y);c.setAttribute('r',r);c.setAttribute('fill','#fff9df');svg.append(c);});
        } else {
          // Verre a vin colore directement dans le SVG, sans dependance aux emojis.
          addPath('M6 3 H22 L20.3 15 Q19.3 21 14 21 Q8.7 21 7.7 15 Z','rgba(255,255,255,.78)','#87223c','1.2');
          addPath('M8.3 10 H19.7 L19 15 Q18.2 19.5 14 19.5 Q9.8 19.5 9 15 Z',tone);
          addPath('M14 21 V28 M9 29 H19',null,'#87223c','1.5');
        }
        glass.append(svg);
        meta.append(glass, element('span', 'pm-result-meta-text', fullMeta));

        const pack = element('strong', 'pm-result-pack', `« ${String(e.pack || '').replace(/[«»]/g, '').trim()} »`);
        const prices = element('div', 'pm-result-prices');
        prices.append(element('strong', 'pm-result-current-price', `${e.price} ${t('tax_included')}`));
        if (priceValue(e.comparePrice) > priceValue(e.price)) {
          prices.append(element('span', 'pm-result-instead-of', ` ${t('instead_of')} `), element('s', 'pm-result-compare-price', `${e.comparePrice} ${t('tax_included')}`));
        }
        const open = element('span', 'pm-result-open', 'Voir la région');
        const category = element('span', 'pm-result-category pm-result-category--badge', `${t(e.selection)} · ${e.region}`);
        o.append(heading, meta, pack, prices, open, category);
        const callback = () => choose(e);
        on(o, 'pointerdown', ev => ev.preventDefault());
        // Le bouton garde l'action existante de choose(e) : selection REGION, pas produit.
        on(o, 'click', ev => { if (ev.target.closest('.pm-result-open, .pm-result-category')) callback(); });
        list.append(o); options.push({ element: o, callback });
      }
      function option(e) {
        return optionMobile(e);
        const o = element('div', 'pm-search-option'); o.setAttribute('role', 'option'); o.id = `${list.id}-${options.length}`; o.setAttribute('aria-selected', 'false');
        const title = element('div', 'pm-result-title');
        const domainName = String(e.domain || '').replace(/[«»"]/g, '').trim();
        title.append(element('strong', '', e.wine), element('span', 'pm-result-domain', domainName ? ' · ' + domainName : ''));
        const detailText = String(e.detail || '').trim();
        const details = detailText.split(/\\s*[·•]\\s*/).filter(Boolean);
        const formatIndex = details.findIndex(v => /\\b\\d+(?:[,.]\\d+)?\\s*cl\\b/i.test(v));
        const format = formatIndex >= 0 ? details.splice(formatIndex, 1)[0].trim() : '';
        const colorYear = details.join(' – ').trim();
        const meta = element('div', 'pm-result-meta');
        if (colorYear) meta.append(element('span', '', ' – ' + colorYear));
        if (format) meta.append(element('span', '', ' · ' + format));
        meta.append(element('span', 'pm-result-open', 'CLIQUEZ ICI'));
        const category = element('span', 'pm-result-category pm-result-category--badge', `${t(e.selection)} · ${e.region}`);
        o.append(title);
        o.append(meta);
        const prices = element('div', 'pm-result-prices');
        const pack = element('strong', 'pm-result-pack', `« ${e.pack.replace(/[«»]/g, '').trim()} »`);
        o.append(pack);
        prices.append(element('strong', 'pm-result-current-price', ` ${e.price} ${t('tax_included')}`));
        if (priceValue(e.comparePrice) > priceValue(e.price)) prices.append(element('span', '', ` ${t('instead_of')} `), element('s', '', `${e.comparePrice} ${t('tax_included')}`));
        o.append(prices);
        o.append(category);
        const callback = () => choose(e);
        on(o, 'pointerdown', ev => ev.preventDefault()); on(o, 'click', ev => { if (ev.target.closest('.pm-result-open, .pm-result-category')) callback(); });
        list.append(o); options.push({ element: o, callback });
      }
      function draw() {
        // Lire les intitules tels qu'ils apparaissent actuellement sur les fiches region,
        // y compris les corrections appliquees apres le chargement initial.
        if (root) entries.forEach(e => {
          const title = cards.get(e.id)?.querySelector('.pm-rhone-card-title');
          if (!title) return;
          const spans = title.children;
          const wine = (spans[1]?.textContent || '').replace(/\s+/g, ' ').trim();
          if (wine) { e.wine = wine; e.appellation = appellation(wine); }
          e.domain = (spans[0]?.textContent || '').replace(/\s+/g, ' ').trim();
        });
        clear.hidden = !input.value; popup.replaceChildren(); list.replaceChildren(); popup.append(list); active = -1; options = []; input.removeAttribute('aria-activedescendant');
        const q = input.value.trim(); if (!q) { close(); return; }
        popup.hidden = false; input.setAttribute('aria-expanded', 'true');
        const nq = normalize(q); const regionQuery = nq.length <= 2 || nq === 'valais' || nq === 'vallee' || nq === 'val';
        const matches = pool().map(e => ({ e, rank: Math.min(...(regionQuery ? [e.region, ...(nq === 'valais' ? ['vallee'] : [])] : [e.appellation, e.wine, e.domain, e.region, e.detail]).map(v => score(nq === 'valais' ? 'vallee' : q, v)).filter(v => v >= 0)) })).filter(r => Number.isFinite(r.rank)).sort((a, b) => priceValue(a.e.price) - priceValue(b.e.price) || a.rank - b.rank || a.e.appellation.localeCompare(b.e.appellation, 'fr') || a.e.domain.localeCompare(b.e.domain, 'fr'));
        matches.slice(0, limit).forEach(({ e }) => option(e));
        status.textContent = `${matches.length} ${t('references')}`; const resultCount = element('div', 'pm-search-result-count', `${matches.length} ${t('references')}`); popup.prepend(resultCount);
        if (matches.length > limit) {
          const more = element('button', 'pm-search-text-button', `${t('more_results')} (${matches.length - limit})`); more.type = 'button'; on(more, 'click', () => { limit += 24; draw(); }); popup.append(more);
        }
        if (!matches.length) {
          popup.append(element('p', 'pm-search-empty', t('no_results')));
          if (scope) { const global = element('button', 'pm-search-text-button', t('all_search')); global.type = 'button'; on(global, 'click', () => { location.hash = 'pm-selections'; const main = widgets.find(w => !w.scope); main?.search(q); close(); }); popup.append(global); }
        }
      }
      function move(n) { if (!options.length) return; active = (n + options.length) % options.length; options.forEach((o, i) => o.element.setAttribute('aria-selected', String(i === active))); input.setAttribute('aria-activedescendant', options[active].element.id); options[active].element.scrollIntoView({ block: 'nearest' }); }
      on(input, 'input', () => { limit = 24; popup.scrollTop = 0; list.scrollTop = 0; draw(); popup.scrollTop = 0; list.scrollTop = 0; });
      on(input, 'focus', () => { if (input.value) draw(); });
      on(input, 'keydown', ev => {
        if (ev.key === 'Escape') { close(); return; }
        if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') { ev.preventDefault(); if (popup.hidden) draw(); move(active + (ev.key === 'ArrowDown' ? 1 : -1)); }
        if (ev.key === 'Enter') { ev.preventDefault(); if (popup.hidden) draw(); popup.scrollTop = 0; list.scrollTop = 0; if (window.matchMedia('(max-width: 720px)').matches) input.blur(); }
      });
      on(clear, 'click', () => { input.value = ''; clear.hidden = true; close(); input.focus(); });
      on(document, 'pointerdown', ev => { if (!box.contains(ev.target)) close(); });
      on(box, 'focusout', ev => { if (window.matchMedia('(max-width: 720px)').matches && input.value.trim()) return; if (!box.contains(ev.relatedTarget)) close(); });
      widgets.push({ scope, close, search(q) { limit = 24; input.value = q; input.focus(); draw(); box.scrollIntoView({ block: 'center' }); } });
    }
    if (root) {
      root.querySelectorAll('.pm-wine-search,.pm-wine-recommendations').forEach(e => e.remove());
      addSearch(root.querySelector('#pm-parcours-intro'), null, 'home');
      root.querySelectorAll('.pm-e240[data-pm-selection]').forEach(p => {
        const anchor = p.querySelector('.pm-region-introduction') || p.querySelector('.pm-region-tax-note') || p.querySelector('.pm240-page-header');
        addSearch(p, p.id.replace('pm-vue-', ''), p.id, anchor);
      });
      on(window, 'hashchange', () => widgets.forEach(w => w.close()));
      const requestedSearch = new URL(location.href).searchParams.get('pm_search');
      if (requestedSearch !== null) {
        location.hash = 'pm-selections';
        requestAnimationFrame(() => widgets.find(w => !w.scope)?.search(requestedSearch));
      }
      const requested = new URL(location.href).searchParams.get('pm_wine');
      if (requested) {
        const target = entries.find(e => (e.productId === requested || e.href === requested) && location.hash === `#pm-selection-${e.panel}`);
        if (target) choose(target);
      }
    }
    document.addEventListener('click', ev => {
      const trigger = ev.target.closest('[data-pm-wine-search-trigger]');
      if (!trigger || !root) return;
      ev.preventDefault(); ev.stopImmediatePropagation();
      location.hash = 'pm-selections';
      requestAnimationFrame(() => widgets.find(w => !w.scope)?.search(''));
    }, { capture: true, signal });
    cleanup = () => abort.abort();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();